import { DEFAULT_EMAIL_TEMPLATES } from '../data/emailTemplates';

const STORAGE_KEY = 'safeguardpro_email_templates';

const readTemplates = () => {
  if (typeof window === 'undefined') return DEFAULT_EMAIL_TEMPLATES;
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(DEFAULT_EMAIL_TEMPLATES));
      return DEFAULT_EMAIL_TEMPLATES;
    }
    const parsed = JSON.parse(raw);
    if (Array.isArray(parsed) && parsed.length) return parsed;
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(DEFAULT_EMAIL_TEMPLATES));
    return DEFAULT_EMAIL_TEMPLATES;
  } catch (error) {
    return DEFAULT_EMAIL_TEMPLATES;
  }
};

const writeTemplates = (templates) => {
  if (typeof window === 'undefined') return;
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(templates));
};

export default class EmailTemplateService {
  list() {
    return readTemplates();
  }

  getByKey(key) {
    return readTemplates().find((template) => template.key === key) || null;
  }

  update(template, user) {
    const templates = readTemplates();
    const next = templates.map((item) =>
      item.key === template.key
        ? {
            ...item,
            ...template,
            updated_by: user?.name || user?.id || 'system',
            updated_at: new Date().toISOString()
          }
        : item
    );
    writeTemplates(next);
    return next.find((item) => item.key === template.key) || template;
  }
}
